import React, { useState, useRef, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Outlet } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './components/Home/Home';
import Macau from './components/Macau/Macau';
import OneOasis from './components/OneOasis/OneOasis';
import Neighborhood from './components/Neighborhood/Neighborhood';
import ApartmentsAndPlans from './components/ApartmentsAndPlans/ApartmentsAndPlans';
import DesignAndMaterial from './components/DesignAndMaterial/DesignAndMaterial';
import PropertyManagement from './components/PropertyManagement/PropertyManagement';
import Clubhouse from './components/Clubhouse/Clubhouse';
import Retail from './components/Retail/Retail';
import InternationalSchools from './components/InternationalSchools/InternationalSchools';
import Gallery from './components/Gallery/Gallery';
import ResidencesGallery from './components/ResidencesGallery/ResidencesGallery';
import AmenitiesGallery from './components/AmenitiesGallery/AmenitiesGallery';
import NeighborhoodGallery from './components/NeighborhoodGallery/NeighborhoodGallery';
import Awards from './components/Awards/Awards';
import SalesContact from './components/SalesContact/SalesContact';
import Developers from './components/Developers/Developers';
import ScrollToTop from './components/ScrollToTop';
import BackToTop from './components/BackToTop/BackToTop';
import GrandOasisFloorplan from './components/GrandOasisFloorplan/GrandOasisFloorplan';
import SkyOasisFloorplan from './components/SkyOasisFloorplan/SkyOasisFloorplan';
import EstablishedCommunity from './components/EstablishedCommunity/EstablishedCommunity';
import { useTranslation } from 'react-i18next';

function AppContent() {
  const location = useLocation();
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const { i18n } = useTranslation();
  
  useEffect(() => {
    document.documentElement.lang = i18n.language;
    document.body.classList.remove('en', 'sc', 'tc');
    document.body.classList.add(i18n.language);
  }, [i18n.language]);

  const togglePlay = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const isBlankPage = location.pathname === '/grandoasis-floorplan' || location.pathname === '/skyoasis-floorplan';

  return (
    <div>
      {!isBlankPage && <audio ref={audioRef} src="/images/videos/bgmusic.mp3" loop />}
      {!isBlankPage && <Header isPlaying={isPlaying} togglePlay={togglePlay} />}
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/location/macau" element={<Macau />} />
        <Route path="/location/one-oasis" element={<OneOasis />} />
        <Route path="/location/neighborhood" element={<Neighborhood />} />
        <Route
          path="/residence/apartments-plans"
          element={<ApartmentsAndPlans />}
        />
        <Route
          path="/residence/design-material"
          element={<DesignAndMaterial />}
        />
        <Route
          path="/residence/property-management"
          element={<PropertyManagement />}
        />
        <Route
          path="/residence/established-community"
          element={<EstablishedCommunity />}
        />
        <Route path="/amenities/clubhouse" element={<Clubhouse />} />
        <Route path="/amenities/retail" element={<Retail />} />
        <Route
          path="/amenities/international-schools"
          element={<InternationalSchools />}
        />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/gallery/residences" element={<ResidencesGallery />} />
        <Route path="/gallery/amenities" element={<AmenitiesGallery />} />
        <Route
          path="/gallery/neighborhood"
          element={<NeighborhoodGallery />}
        />
        <Route path="/awards" element={<Awards />} />
        <Route path="/contact/sales-contact" element={<SalesContact />} />
        <Route path="/contact/developers" element={<Developers />} />
        <Route path="/grandoasis-floorplan" element={<GrandOasisFloorplan />} />
        <Route path="/skyoasis-floorplan" element={<SkyOasisFloorplan />} />
      </Routes>
      {!isBlankPage && <Footer />}
      <BackToTop />
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;
